import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-route-splash',
  templateUrl: './route-splash.component.html',
  styleUrls: ['./route-splash.component.scss'],
})
export class RouteSplashComponent {}
